import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import AppContext from "../../../../context/AppContext";
import useTspPermission from "../../hooks/useTspPermission";
import TspNav from "./TspNav";

// TSP's own header — replaces the shared ICC Header on /tsp/* routes (per the
// approved Phase A plan) and matches the approved header design: brand, search,
// profile, then the primary nav. Reuses AppContext's real `user` (shared infra)
// instead of inventing new state. There is no notification bell in the header.

// "Prithvi Sharma" -> "PS" (the design shows two-letter initials).
function initialsOf(name) {
  const parts = (name || "").trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  return (parts[0][0] + (parts.length > 1 ? parts[parts.length - 1][0] : "")).toUpperCase();
}

export default function TspHeader() {
  const { user } = useContext(AppContext);
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  useTspPermission();

  const handleSearch = (event) => {
    event.preventDefault();
    const trimmed = query.trim();
    navigate(trimmed ? `/tsp/search?q=${encodeURIComponent(trimmed)}` : "/tsp/search");
  };

  return (
    <header className="tsp-header">
      <div className="tsp-header-top">
        <Link to="/tsp" className="tsp-brand">
          <img src="/images/common/logo.png" alt="ISKCON" className="tsp-brand-logo" />
          <span className="tsp-brand-text">
            <span className="tsp-brand-title">Bus Party</span>
            <span className="tsp-brand-subtitle">MANAGEMENT APPLICATION</span>
          </span>
        </Link>

        <div className="tsp-header-actions">
          <form className="tsp-search" role="search" onSubmit={handleSearch}>
            <Search size={15} aria-hidden="true" />
            <input type="search" placeholder="Search..." aria-label="Search TSP" value={query} onChange={(event) => setQuery(event.target.value)} />
          </form>

          <div className="tsp-profile">
            <div className="tsp-profile-trigger">
              <span className="tsp-profile-avatar" aria-hidden="true">
                {initialsOf(user?.name)}
              </span>
              <span className="tsp-profile-text">
                <span className="tsp-profile-hi" title={user?.name}>
                  Hi {user?.name}
                </span>
                <span className="tsp-profile-role" title={user?.role}>
                  {user?.role}
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="tsp-nav-row" id="tsp-header-menu">
        <TspNav />
      </div>
    </header>
  );
}
